import type { AdminNatCodesCode } from '#api/tmsApiService'
import { isValidPeriod, type PartPeriod, periodToDate } from '#utils/DateString'

export function buildPartPeriodValidityFilter(start: PartPeriod | undefined, end: PartPeriod | undefined) {
  const startAsDate = start ? periodToDate(start) : undefined
  const endAsDate = end ? periodToDate(end) : undefined

  return (code: AdminNatCodesCode): boolean => {
    if (startAsDate) {
      const validFromDate = isValidPeriod(code.validFrom) ? periodToDate(code.validFrom) : undefined
      if (validFromDate && validFromDate > startAsDate) {
        return false
      }
    }

    if (endAsDate) {
      const validToDate = isValidPeriod(code.validTo) ? periodToDate(code.validTo) : undefined
      if (validToDate && validToDate < endAsDate) {
        return false
      }
    }

    return true
  }
}
